import { ProcessType } from '../configuration-options/process-type';

export class AutoFillDefinition {
	LookupTableName: string;
	QueryModuleId: string;
	QueryId: string;
	ApiUrl: string;

	DefaultName: string;
	PreviewFields: Record<string, string>;
	ControlValueMappings: Record<string, Record<string, string>>;
	EnabledWhen: Record<string, string>;
	IsEnabledOffline: boolean;
	ProcessType: ProcessType;
	MatchType: string;
	DefaultField: string;
	FailValidationOnFailedLookup: boolean;
	PublishAnywayOnFailedLookup: boolean;
	AllowMappingAfterFirstSave: boolean;
}
